import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

export const TEST_NAME_CHECKOUT_OPTIMIZATION = 'CheckoutHeaderBannerOptimizations';

export const isCheckoutOptimizationVariant = (): boolean =>
    getAbTestV2(TEST_NAME_CHECKOUT_OPTIMIZATION)?.variant === 'variant';

export const trackCheckoutOptimizationVariant = (): void =>
    trackAbTestV2Variant(TEST_NAME_CHECKOUT_OPTIMIZATION);
